export default __webpack_public_path__ + "_/images/marketplace/slot-armor-8bfdbc04a3229abca12a1d8674d42cdcc9e19b194c4a686b31c146a7f73132f8.png";